/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const ClockIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M12 1.2c5.965 0 10.8 4.835 10.8 10.8 0 5.965-4.835 10.8-10.8 10.8-5.965 0-10.8-4.835-10.8-10.8C1.2 6.035 6.035 1.2 12 1.2zm0 2.4a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8zM12 6c.663 0 1.2.412 1.2 2.4v2.812c0 .49 0 .736.091.956.08.193.223.35.49.618l.97.971c1.406 1.406 1.318 2.077.849 2.546-.469.469-1.14.557-2.546-.849l-.848-.848c-.694-.694-1.04-1.04-1.223-1.482-.153-.367-.178-.77-.182-1.46L10.8 8.4c0-1.988.537-2.4 1.2-2.4z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
ClockIconSvg.displayName = 'ClockIconSvg'

const ClockIcon = forwardRef((props, ref) => <Icon component={ClockIconSvg} ref={ref} {...props} />)
ClockIcon.displayName = 'ClockIcon'

ClockIcon.defaultProps = {
	...Icon.defaultProps,
}
ClockIcon.propTypes = {
	...Icon.propTypes,
}

export default ClockIcon
export { ClockIconSvg }
